import React from "react";

const FirstHalfLeave = ({style = {}, size = "36", className = "", fill="none", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M19 34h-2c-.39-.048-.782-.09-1.17-.146-3.207-.459-6.037-1.748-8.45-3.908-2.752-2.463-4.472-5.519-5.13-9.159-.107-.59-.168-1.19-.25-1.787v-2c.048-.39.089-.782.145-1.172.504-3.487 1.974-6.505 4.443-9.02 2.396-2.44 5.284-3.968 8.656-4.562.582-.103 1.17-.165 1.756-.246h2c.545.071 1.093.124 1.634.216 2.994.513 5.644 1.76 7.917 3.776 2.797 2.48 4.545 5.563 5.203 9.251.104.582.165 1.17.245 1.757v2c-.017.08-.045.16-.052.241-.187 2.458-.89 4.76-2.168 6.865-2.538 4.175-6.212 6.743-11.025 7.649-.579.11-1.169.164-1.754.245zM17.995 4.672c-7.364.008-13.338 5.99-13.322 13.34A13.33 13.33 0 0017.99 31.328c7.351.015 13.335-5.963 13.337-13.325.003-7.36-5.975-13.337-13.331-13.33z"
            fill="#1E2538"
        />
        <path className="u_fill"
            d="M18.328 18.009c0 3.218 0 6.437.002 9.656 0 .298-.02.583-.24.815-.227.24-.512.286-.827.281a10.786 10.786 0 01-10.19-7.828c-1.781-6.28 2.418-12.7 8.903-13.602.442-.061.892-.077 1.34-.09.655-.017 1.01.33 1.01.988.005 2.114.002 4.23.002 6.344v3.436z"
          fill={fill}
        />
    </svg>
);

export default FirstHalfLeave;
